var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "449px",
    height: "448px",
    viewBox: "0 0 449 448",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-in",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.3,448 L7.4,448 L7.4,148.9 L100.3,148.9 L100.3,448 Z M53.8,108.1 C24.1,108.1 0,83.5 0,53.8 C0,24.1 24.1,0 53.8,0 C83.5,0 107.6,24.1 107.6,53.8 C107.6,83.5 83.5,108.1 53.8,108.1 Z M448,448 L355.3,448 L355.3,302.4 C355.3,267.7 354.6,223.2 307,223.2 C258.7,223.2 251.3,260.9 251.3,299.9 L251.3,448 L158.5,448 L158.5,148.9 L247.6,148.9 L247.6,189.7 L248.9,189.7 C261.3,166.2 291.6,141.4 336.8,141.4 C430.8,141.4 448.1,203.3 448.1,283.7 L448.1,448 L448,448 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinin);
export default __webpack_public_path__ + "static/media/linkedinin.3bf60208cff3866801830313d75aa53a.svg";
export { ForwardRef as ReactComponent };